export default __webpack_public_path__ + "static/media/facebookLogo.37260e9c.svg";